export default {
  Insurer: 1,
  Private: 2,
  ThirdParty: 3,
  GstThirdParty: 4,
  GstCustomer: 5
}
